import { MadisonChatBubble } from "./MadisonChatBubble";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export const GlobalMadison = () => {
  const location = useLocation();
  const { user } = useAuth();

  // Only show Madison on specific in-app pages
  const showMadisonPages = ["/", "/checkin", "/promos", "/promoslocales"];
  const shouldShowMadison = showMadisonPages.includes(location.pathname);

  // Never show on the public marketing website (logged-out visitors)
  if (!user || !shouldShowMadison) return null;

  return <MadisonChatBubble />;
};
